import {
  CODE_SUGGESTIONS_EXTENSION_KEY,
  CODE_SUGGESTIONS_EXTENSION_TYPE,
} from 'src/components/code-suggestions/constants';
import { ADF, FabricComment } from 'src/components/conversation-provider/types';

export const commentHasCodeSuggestions = (comment: FabricComment): boolean => {
  return (
    comment.document?.adf?.content.some(
      content =>
        content.type === 'extension' &&
        content.attrs.extensionKey === CODE_SUGGESTIONS_EXTENSION_KEY &&
        content.attrs.extensionType === CODE_SUGGESTIONS_EXTENSION_TYPE
    ) ?? false
  );
};

export const extractTextFromADF = (
  adf: ADF,
  passedNodeType: string | null = null
): string => {
  let text = '';

  // Keep track of the previous node type
  let previousNodeType: string | null = passedNodeType || null;

  // Iterate through all content
  adf.content.forEach(content => {
    // If the content has "text" property, append it to the string with or without a newline character
    if (Object.prototype.hasOwnProperty.call(content, 'text')) {
      // Handle text content based on node type
      const isFirstNode = previousNodeType === null;
      const isSameType = content.type === previousNodeType;

      const hasCodeMark = content.marks?.some(
        (mark: { type: string }) => mark.type === 'code'
      );
      const textToAppend = hasCodeMark ? `\`${content.text}\`` : content.text;

      if (isFirstNode) {
        text += textToAppend;
      } else {
        text += isSameType ? ` ${textToAppend}` : `\n${textToAppend}`;
      }

      previousNodeType = content.type;
    }
    // If the content has "content" property, recurse through it
    if (Object.prototype.hasOwnProperty.call(content, 'content')) {
      text += extractTextFromADF(content, previousNodeType);
    }
    // Handle extension blocks with code suggestions
    if (
      content.type === 'extension' &&
      content.attrs?.parameters?.suggestionText
    ) {
      text += `\n${content.attrs.parameters.suggestionText}`;
      previousNodeType = content.type;
    }
  });

  return text;
};

export const isCommentReply = (comment: FabricComment): boolean => {
  return (
    comment.parentId !== undefined &&
    comment.parentId !== null &&
    !isNaN(comment.parentId)
  );
};
